/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// reactstrap components
import {Card, CardBody, CardTitle, Col, Container, Row} from "reactstrap";
import {Redirect} from "react-router-dom";
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {student_strings} from "../../translations/student_translations";
import businessHelper from "../../helpers/BusinessHelper";

const test_stats = {
    "total": 120,
    "total_perc": 20,
    "active": 90,
    "active_perc": -11,
};

let studentStrings = new LocalizedStrings(student_strings);

class ClientsHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            stats: test_stats,
            activeSelected: this.props.activeOnly || false,
            sueltaSelected: this.props.sueltaOnly || false,
            language: localeHelpers.currentLocale()
        };
    }

    onAllClicked = this.onAllClicked.bind(this)
    onActiveClicked = this.onActiveClicked.bind(this)
    onSueltaClicked = this.onSueltaClicked.bind(this)

    componentDidMount() {
        this.setState({isLoading: true});

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.activeOnly !== this.state.activeSelected) {
            this.setState({activeSelected: prevProps.activeOnly})
        }

        if (prevProps.sueltaOnly !== this.state.sueltaSelected) {
            this.setState({sueltaSelected: prevProps.sueltaOnly})
        }
    }

    render() {
        studentStrings.setLanguage(this.state.language);
        return (
            <>
                <div className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                     style={{
                         backgroundImage: "url(" + businessHelper.backgroundImage("clients") + ")",
                         backgroundSize: "cover",
                         backgroundPosition: "center top"
                     }}
                >
                    {/* Mask */}
                    <span className="mask bg-gradient-dark opacity-9"/>
                    <Container fluid>
                        <div className="header-body">
                            {/* Card stats */}
                            <Row>
                                <Col>
                                    <Card className="card-stats mb-4 mb-xl-0" onClick={(e) => this.onAllClicked(e)}
                                          style={{cursor: "pointer", minHeight: 100}}>
                                        <CardBody>
                                            <Row>
                                                <div className="col">
                                                    <CardTitle
                                                        tag="h5"
                                                        className="text-uppercase text-muted mb-0"
                                                    >
                                                        {studentStrings.clients_total}
                                                    </CardTitle>
                                                    <span className="h2 font-weight-bold mb-0">
                                                    {this.props && this.props.total ? this.props.total : "0"}
                                                    </span>
                                                </div>
                                                <Col className="col-auto">
                                                    <div
                                                        className="icon icon-shape bg-warning text-white rounded-circle shadow">
                                                        <i className="fas fa-users"/>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col>
                                    <Card
                                        className={this.state.activeSelected ? "card-stats mb-4 mb-xl-0 bg-gradient-danger" : "card-stats mb-4 mb-xl-0"}
                                        onClick={(e) => this.onActiveClicked(e)}
                                        style={{cursor: "pointer", minHeight: 100}}>
                                        <CardBody>
                                            <Row>
                                                <div className="col">
                                                    <CardTitle
                                                        tag="h5"
                                                        className={this.state.activeSelected ? "text-uppercase text-white mb-0" : "text-uppercase text-muted mb-0"}
                                                    >
                                                        {studentStrings.clients_active}
                                                    </CardTitle>
                                                    <span
                                                        className={this.state.activeSelected ? "h2 font-weight-bold mb-0 text-white" : "h2 font-weight-bold mb-0"}
                                                        >
                                                      {this.props && this.props.active ? this.props.active : "0"}
                                                    </span>
                                                </div>
                                                <Col className="col-auto">
                                                    <div
                                                        className="icon icon-shape bg-success text-white rounded-circle shadow">
                                                        <i className="fas fa-users"/>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>

                                {businessHelper.business().id == 52 &&
                                <Col>
                                    <Card
                                        className={this.state.sueltaSelected ? "card-stats mb-4 mb-xl-0 bg-gradient-red" : "card-stats mb-4 mb-xl-0"}
                                        onClick={(e) => this.onSueltaClicked(e)}
                                        style={{cursor: "pointer", minHeight: 100}}>
                                        <CardBody>
                                            <Row>
                                                <div className="col">
                                                    <CardTitle
                                                        tag="h5"
                                                        className="text-uppercase text-muted mb-0"
                                                    >
                                                        Clase Suelta tickets activos
                                                    </CardTitle>
                                                    <span className="h2 font-weight-bold mb-0">
                                                      {this.props && this.props.suelta ? this.props.suelta : "0"}
                                                    </span>
                                                </div>
                                                <Col className="col-auto">
                                                    <div
                                                        className="icon icon-shape bg-blue text-white rounded-circle shadow">
                                                        <i className="fas fa-calendar-day"/>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                                }
                            </Row>
                        </div>
                    </Container>
                </div>
            </>
        );
    }

    onActiveClicked(e) {
        e.preventDefault();
        this.setState({activeSelected: true})
        this.props.onActiveSelected()
    }

    onSueltaClicked(e) {
        e.preventDefault();
        this.setState({sueltaSelected: true})
        this.props.onSueltaSelected()
    }

    onAllClicked(e) {
        e.preventDefault();
        this.setState({activeSelected: false})
        this.props.onActiveDeselected()
    }
}

export default ClientsHeader;
